
<div class="modal-dialog confirm-dialog" style="display: flex; justify-content: center;">
  <div class="modal-content" style="min-width:930px;">
    <form [formGroup]="k2Sites.form">
      <div class="modal-header">
        <h4 class="modal-title">Import K2 Sites</h4>
        <button class="close" type="button" (click)="cancel()">&times;</button>
      </div>
      <div class="modal-body">
        <error [error]="error"></error>
        <list-controls [search]="k2Sites.searchText" [limit]="k2Sites.pageSize" [page]="k2Sites.currentPage" [numPages]="k2Sites.maxPages" [totalCount]="k2Sites.filteredLength" (onChange)="k2Sites.onListControlsChange($event)"></list-controls>
        <table class="table table-striped" formArrayName="items">
          <thead>
            <tr *ngIf="!!k2Sites.filtered.length">
              <th></th>
              <th>Site</th>
              <th>Address</th>
              <th>City</th>
              <th>Region</th>
              <th>zipCode</th>
            </tr>
          </thead>
          <tbody>
            <ng-template [ngIf]="!loading &amp;&amp; k2Sites.filtered.length">
              <tr *ngFor="let site of k2Sites.filtered" [formGroupName]="site.index">
                <td class="td-width">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" formControlName="selected" (change)="updateSelection()">
                  </div>
                </td>
                <td>{{ site.name }}</td>
                <td>{{ site.address }}</td>
                <td>{{ site.city }}</td>
                <td>{{ site.region }}</td>
                <td>{{ site.zipCode }}</td>
              </tr>
            </ng-template>
            <ng-template [ngIf]="!loading &amp;&amp; !k2Sites.filtered.length">
              <tr>
                <td colspan="8">
                  <p class="text-center empty-table-message">There are no sites to display.</p>
                </td>
              </tr>
            </ng-template>
            <ng-template [ngIf]="loading">
              <tr>
                <td colspan="8">
                  <md-spinner-block></md-spinner-block>
                </td>
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>
      <div class="modal-footer" style="display: flex; justify-content: start;"><span>Selected {{ this.selectedCount }} site(s)</span><a class="btn btn-link disabled" *ngIf="!selectedCount || !k2Sites.searchFiltered.length" href="javascript:void(0);">Deselect all</a><a class="btn btn-link" *ngIf="selectedCount &amp;&amp; k2Sites.searchFiltered.length" href="javascript:void(0);" (click)="deselectAll()">Deselect all</a><a class="btn btn-link disabled" *ngIf="!k2Sites.searchFiltered.length" href="javascript:void(0);">Select All</a><a class="btn btn-link" *ngIf="!!k2Sites.searchFiltered.length" href="javascript:void(0);" (click)="selectAll()">Select all</a><a class="btn btn-outline-secondary px-4 ml-auto" href="javascript:void(0);" (click)="cancel()">Cancel</a><a class="btn btn-primary px-4 disabled" *ngIf="!selectedCount" href="javascript:void(0);">Import</a><a class="btn btn-primary px-4" *ngIf="!!selectedCount" href="javascript:void(0);" (click)="importSites()">Import</a></div>
    </form>
  </div>
</div>